import { createAsyncThunk } from '@reduxjs/toolkit';
import { setUserId } from '@snowplow/browser-tracker';

import { userAPI } from '@/modules/user/api';
import type { User } from '@/modules/user/model';
import { namespace } from '@/modules/user/namespace';
import { userSlice } from '@/modules/user/store/slice';
import { errorHandling } from '@/services/errorHandling';

const loadUser = createAsyncThunk(
  `${namespace}/load-user`,
  async (_, { dispatch }): Promise<User> => {
    const myUser = await userAPI.readUserData();

    errorHandling.identify({ id: myUser.userId, email: myUser.email });
    setUserId(myUser.userId);

    dispatch(userSlice.actions.setUserData(myUser));

    return myUser;
  },
);

export { loadUser };
